import router from './router'
import bankingMessages from './localization'

export default {
  router,
  localization: bankingMessages,
}
